var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.221,
    height: 18.034,
    viewBox: "0 0 19.221 18.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Health",
    transform: "translate(-869.39 -7562.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-health-1406197",
    transform: "translate(758.722 7506.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M129.047,63.608h-5.056a.678.678,0,0,0-.5.2l-2.054,2.167-2.37-5.3a.677.677,0,0,0-1.2-.09L116,63.653h-4.334v1.354h4.717a.677.677,0,0,0,.587-.316l1.377-2.28,2.257,5.1a.677.677,0,0,0,.5.384h.113a.677.677,0,0,0,.5-.2l2.551-2.708h4.063C128.724,64.194,129.037,63.616,129.047,63.608Z",
    transform: "translate(0 0)",
    fill: "#f28d18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-health-1406197-2",
    "data-name": "noun-health-1406197",
    transform: "translate(757.948 7506.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1555-2",
    "data-name": "Path 1555",
    d: "M128.934,57.784a5.169,5.169,0,0,0-3.747-1.58h-.045a6.523,6.523,0,0,0-4.153,1.557,5.328,5.328,0,0,0-7.945.022,6.072,6.072,0,0,0-1.6,3.137l1.332.248a4.717,4.717,0,0,1,1.264-2.438,4.491,4.491,0,0,1,3.25-1.377,5.15,5.15,0,0,1,3.228,1.783.722.722,0,0,0,1.016,0,5.236,5.236,0,0,1,3.634-1.58h.023a3.837,3.837,0,0,1,2.776,1.151,4.763,4.763,0,0,1,1.354,3.34,4.894,4.894,0,0,1-.271,1.557,8.346,8.346,0,0,1-.722,1.377l-.339.406-6.974,6.771-5.53-5.349-.948.97,6.478,6.252,7.922-7.651a6.184,6.184,0,0,0,0-8.577Z",
    transform: "translate(0 0)",
    fill: "#0077b6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.75b34f8dca9aa3b2df8db63a25ba9340.svg";
export { ForwardRef as ReactComponent };